import { render } from "./privacy_policy.vue?vue&type=template&id=e812d9b4&scoped=true"
import script from "./privacy_policy.vue?vue&type=script&lang=js"
export * from "./privacy_policy.vue?vue&type=script&lang=js"

import "./privacy_policy.vue?vue&type=style&index=0&id=e812d9b4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/3b689470-9235-485d-ba5a-49630a920e29/workspace/wellcee-h5-p_H4zR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e812d9b4"]])

export default __exports__